<template>
  <Modal @cancel="close()" v-if="campaignId" cClass="ab-test__modal">
    <template #header>
      <div>
        <p class="typo-heading20 typo-medium typo-bold text-light-low">
          {{ $t("abTest.modalTitle") }}
        </p>
      </div>
    </template>
    <template #default>
      <div>
        <p class="typo-paragraph14 text-light-low mb-4">
          <span v-html="$t('abTest.modalDes1')"></span>
          <a :href="campaignLink" class="text-mono3">{{ $t("abTest.modalLink") }}</a>
          <span>{{ $t("abTest.modalDes2") }}</span>
        </p>
        <div class="d-flex justify-content-lg-end">
          <span class="bg-mono3 px-5 py-12px border-radius clickable text-dark-high" @click="close()">
            <span>{{ $t("abTest.gotIt") }}</span>
          </span>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "AbTestingBlockModal",
  computed: {
    ...mapState("page", {
      campaignId: state => state.abTestingBlockModal,
    }),
    campaignLink() {
      return `/analytics/experiments/${this.campaignId}`;
    }
  },
  methods: {
    close() {
      this.$store.commit("page/OPEN_AB_TESTING_BLOCK_MODAL", false);
    }
  }
};
</script>

<style lang="scss">
.ab-test {
  &__modal {
    max-width: 424px;
  }
}
</style>
